import { useEffect } from "react";
import { NoirBar, NoirFooter } from "./NoirChrome";
import { changelogEntries, formatChangelogDate } from "./changelogContent";
import "./MarketingPage.css";
import "./LegalPage.css";

// What changed, newest first. One entry per release day, written for the people who use LoopGroup.

export function ChangelogPage() {
  const latest = changelogEntries[0];

  useEffect(() => {
    document.title = "Changelog · LoopGroup";
    if (!window.location.hash) window.scrollTo(0, 0);
  }, []);

  return (
    <div className="noir legal changelog">
      <NoirBar />
      <main className="legal__main">
        <header className="legal__head">
          <p className="noir__eyebrow">Changelog</p>
          <h1 className="legal__title">What changed.</h1>
          <p className="legal__lede">Every release since the black system, newest first. Written for the people who use LoopGroup, not the people who built it.</p>
          <p className="legal__effective">
            <span>Latest</span> <time dateTime={latest.date}>{formatChangelogDate(latest.date)}</time>
          </p>
        </header>

        <ol className="changelog__list" aria-label="Releases">
          {changelogEntries.map((entry) => (
            <li className="changelog__entry" key={entry.date} id={entry.date}>
              <time className="changelog__date" dateTime={entry.date}>{formatChangelogDate(entry.date)}</time>
              <div>
                <h2>{entry.title}</h2>
                <ul>
                  {entry.items.map((item) => <li key={item}>{item}</li>)}
                </ul>
              </div>
            </li>
          ))}
        </ol>
      </main>
      <NoirFooter />
    </div>
  );
}
